(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fairtex-size-guide"] && !Shopify.designMode) return;
  try {
    
  function fxSwitchUnit(scope, index) {
    var idx = String(index);
    scope.querySelectorAll('.unit-btn').forEach(function (b) {
      var on = b.dataset.unitIndex === idx;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    scope.querySelectorAll('.unit-table').forEach(function (t) {
      t.classList.toggle('active', t.dataset.unitIndex === idx);
    });
  }

  function fxInitUnitToggles(root) {
    var sync = root.dataset.syncUnits === 'true';
    root.querySelectorAll('.unit-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.dataset.unitIndex;
        if (sync) {
          fxSwitchUnit(root, index);
        } else {
          var item = btn.closest('.item');
          if (item) fxSwitchUnit(item, index);
        }
      });
    });
  }

  function fxInitSizeGuide(root) {
    if (!root || root.dataset.fxInit === 'true') return;
    root.dataset.fxInit = 'true';

    var buttons = root.querySelectorAll('.tab-btn');
    var panels = root.querySelectorAll('.panel');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('active'); });

        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');

        var target = root.querySelector('#' + btn.getAttribute('data-tab'));
        if (target) target.classList.add('active');
      });
    });

    fxInitUnitToggles(root);
  }

  function fxInitAll() {
    document.querySelectorAll('.fx-size-guide').forEach(fxInitSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fxInitAll);
  } else {
    fxInitAll();
  }

  // Theme editor: re-init when the section is added or re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.fx-size-guide');
    if (root) { root.dataset.fxInit = 'false'; fxInitSizeGuide(root); }
  });

  } catch(e) { console.error(e); }
})();
})();
